<app-attention-modal type="error" title="Unsaved changes" [messageTemplate]="message" [buttonsTemplate]="buttons"></app-attention-modal>

<ng-template #message> You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes. </ng-template>

<ng-template #buttons>
  <button rktButton btnType="tertiary" title="Cancel" (click)="activeModal.close()">Cancel</button>
  <button rktButton title="OK" (click)="activeModal.close(true)">OK</button>
</ng-template>
